import * as auth from './auth';
import * as firebase from './firebase';
import * as db from './db';
import * as storage from './storage';
export {
    auth,
    firebase,
    db,
    storage,
};


// WEBPACK FOOTER //
// ./src/firebase/index.js